import React from 'react';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { columns } from '../internals/data/vehicleData';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';

function generateExportFileName() {
  return "Fleets-" + dayjs().format('YYYY-MM-DD HH:mm:ss');
}

export default function FleetDataGrid({ fleetData }) {

  const navigate = useNavigate();

  const handleCellClick = (params) => {
    // console.log('Cell clicked:', params);
    navigate(`/battery-packs/${params.row.battery_pack_IMEI}`);
  };

  return (
    <DataGrid
      checkboxSelection
      rows={fleetData}
      columns={columns}
      getRowClassName={(params) =>
        params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
      }
      // initialState={{
      //   pagination: { paginationModel: { pageSize: 11 } },
      // }}
      // pageSizeOptions={[10, 20, 50]}
      onCellClick={handleCellClick}
      disableColumnResize
      density="compact"
      slots={{ toolbar: GridToolbar }}
      slotProps={{
        toolbar: {
          showQuickFilter: true,
        },
        csvOptions: { fileName: generateExportFileName() },
        printOptions: { fileName: generateExportFileName(), hideToolbar: true, },
        filterPanel: {
          filterFormProps: {
            logicOperatorInputProps: {
              variant: 'outlined',
              size: 'small',
            },
            columnInputProps: {
              variant: 'outlined',
              size: 'small',
              sx: { mt: 'auto' },
            },
            operatorInputProps: {
              variant: 'outlined',
              size: 'small',
              sx: { mt: 'auto' },
            },
            valueInputProps: {
              InputComponentProps: {
                variant: 'outlined',
                size: 'small',
              },
            },
          },
        },
      }}
    />
  );
}
